import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var LanguageSwitcherCss = i`
  :host {
    font-family: var(--isceco-font)
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    width: 24px;
    line-height: 24px;
    margin-left: 8px;
    float: left; /* fix gap between items */
    font-size: 0.875rem;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: var(--isceco-color-black-500);
  }

  li:hover {
    text-decoration: underline;
  }

  li.active {
    background-color: var(--isceco-color-background);
    font-weight: bold;
  }
`;
export { LanguageSwitcherCss as default };
